<template>
	<ja-modal ref="modal" :show="show" @close-modal="closeModal">
		<content class="your-future-modal">
			<h1>{{ $t('yourFutureTitle') }}</h1>
			<div class="body-text-1 subtitle-your-future">
				{{ $t('subtitleYourFuture') }}
			</div>
			<div class="card-container">
				<ja-card
					v-for="(option, index) in filteredFutureEvents"
					:key="index"
					:selected="futureOptionIsSelected(option)"
					class="card-your-future"
					:aria-label="option"
					role="switch"
					:aria-checked="futureOptionIsSelected(option).toString()"
					@click.native="toggleYourFutureSelection(option)"
				>
					<div class="image-wrapper">
						<img
							class="card-image"
							:src="
								require(`@/assets/images/hopes-and-dreams/${option
									.split(' ')
									.join('')
									.toLowerCase()}.png`)
							"
							alt=""
						/>
					</div>
					<div class="heading-5 card-title">
						{{ option }}
					</div>

					<ja-multiselect-circle
						aria-hidden="true"
						tabindex="-1"
						:selected="futureOptionIsSelected(option)"
					></ja-multiselect-circle>
				</ja-card>
			</div>
			<ja-button
				class="small"
				name="close-your-future"
				@click.native.once="submitSelection"
				>{{ $t('finish') }}</ja-button
			>

			<ja-close-button
				name="close"
				@click.native="closeModal"
				@keydown.esc="closeModal"
			></ja-close-button>
		</content>
	</ja-modal>
</template>
<script>
import LifeStageData from '@/mixins/LifeStageData';
import ProfileData from '@/mixins/ProfileData';
import ModalEvents from '@/mixins/ModalEvents';
import Modal from './Modal';
import Button from '../ui/Button';
import Card from '../ui/Card';
import gql from 'graphql-tag';
import MultiselectCircle from '../ui/MultiselectCircle';
import CloseButton from '../ui/CloseButton';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button,
		jaCard: Card,
		jaMultiselectCircle: MultiselectCircle,
		jaCloseButton: CloseButton
	},
	mixins: [LifeStageData, ProfileData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			futureEvents: [],
			selectedFutureEvents: [],
			addYourFutureErrorMessage: null
		};
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		},
		filteredFutureEvents() {
			if (this.profileData.marital_Status_ID == 2) {
				return this.futureEvents.filter(e => e !== 'Get Married');
			} else {
				return this.futureEvents;
			}
		},

		YOUNG_ADULT_LIFE_STAGE_ID() {
			if (this.constants) {
				return this.constants.youngAdultLifeStageGuid;
			}
			return null;
		}
	},
	apollo: {
		futureEvents: {
			query: gql`
				{
					enumUserFriendlyValues(enumType: "futureEventTypes")
				}
			`,
			update: function(data) {
				return data.enumUserFriendlyValues;
			}
		}
	},

	methods: {
		closeModal() {
			this.$emit('closeModal');
		},

		toggleYourFutureSelection(option) {
			if (this.futureOptionIsSelected(option)) {
				var selectedOptionIndex = this.selectedFutureEvents.findIndex(
					x => x === option
				);

				this.selectedFutureEvents.splice(selectedOptionIndex, 1);
			} else {
				this.selectedFutureEvents.push(option);
			}
		},

		futureOptionIsSelected(option) {
			return this.selectedFutureEvents.some(x => x === option);
		},
		async submitSelection() {
			this.$store.commit('setLoading', true);
			const updateData = {
				id: this.lifeStageData.id,
				hideHopesAndDreamsPopup: true
			};

			if (this.selectedFutureEvents.length) {
				if (this.childrenCount && this.lifeStageData.nextLifeStageID) {
					this.incrementChildrenAgeGroup();
				}

				this.selectedFutureEvents.forEach(option => {
					if (option == 'Have a Child') {
						this.addChildForStudent();
					}
					if (option == 'Get Married') {
						updateData.marital_Status_ID = 2;
					}
					if (option == 'Have a Pet') {
						updateData.numberOfPets = this.profileData.numberOfPets + 1;
					}
				});
			}
			this.updateStudentData(updateData)
				.then(response => {
					if (response) {
						this.$store.commit('setLoading', false);
						this.$emit('closeModal');
					}
				})
				.catch(error => {
					this.addYourFutureErrorMessage = error;
					this.$store.commit('setLoading', false);
					this.$emit('closeModal');
				});
		},

		async updateStudentData(updateData) {
			return await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentInputObjectGraphType!) {
						updateStudent(update: $update) {
							id
						}
					}
				`,
				variables: {
					update: updateData
				}
			});
		},

		async incrementChildrenAgeGroup() {
			let updateArray = [];
			let children = this.profileData.studentChildren;
			children.forEach(child => {
				if (child.ageGroup === 'Infant') {
					updateArray.push({ id: child.id, ageGroup: 'Child' });
				}
				if (child.ageGroup === 'Child') {
					updateArray.push({ id: child.id, ageGroup: 'Teenager' });
				}
			});

			updateArray.forEach(updateData => this.updateChild(updateData));
		},

		async updateChild(updateData) {
			await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentChildInputObjectGraphType!) {
						updateStudentChild(update: $update) {
							id
						}
					}
				`,
				variables: {
					update: updateData
				}
			});
		},

		async addChildForStudent() {
			await this.$apollo.mutate({
				mutation: gql`
					mutation($add: StudentChildAddInputObjectGraphType!) {
						addStudentChild(add: $add) {
							id
						}
					}
				`,
				variables: {
					add: {
						studentId: this.lifeStageData.id,
						lifeStage_ID: this.lifeStageData.lifeStage_ID,
						ageGroup: 'Infant'
					}
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.your-future-modal {
	padding: 64px 86px;

	h1 {
		margin: 0;
		font-family: 'RobotoRegular';
	}

	.subtitle-your-future {
		margin-top: 22px;
		margin-bottom: 32px;
	}

	.card-container {
		display: flex;

		.card-your-future {
			padding: 24px 32px;
			padding-bottom: 38px;
			margin-bottom: 32px;
			line-height: 23px;
			min-height: 320px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;

			&:not(:first-child) {
				margin-left: 15px;
			}

			@media (max-width: $breakpoint-mid) {
				padding: 24px 15px;
			}

			.image-wrapper {
				min-height: 140px;
				min-width: 120px;
				display: flex;
				align-items: center;
				justify-content: center;

				.card-image {
					background-repeat: no-repeat;
				}
			}
			.card-title {
				text-transform: none;
				font-size: 18px;
				letter-spacing: 0.8px;
				font-family: 'RobotoRegular';
			}
			::v-deep .multi-select-circle {
				svg {
					margin-right: 0px;
				}
			}
		}
	}
}
</style>
